import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetOrderQuery = (order_uid: string) => {
  return useQuery({
    queryKey: ['getOrder', order_uid],
    queryFn: () => Api.orders.getOrder(order_uid),
    enabled: !!order_uid,
  });
};
